import {
  MemberProductPaymentRatesChargeCode,
  MemberServiceOfferingUsage,
} from "@/services/core-api-adapter";
import AvailablePromoCodesModalV1 from "./v1";
import AvailablePromoCodesModalV2 from "./v2";
import {
  FeatureToggleIdentifier,
  isFeatureEnabled,
} from "@/services/feature-toggle-adapter";

interface AvailablePromoCodesModalProps {
  isModalOpen: boolean;
  onModalClose: () => void;
  onContinueButtonClick: (voucherOrPromoId?: string) => void;
  onSkipButtonClick: () => void;
  selectedConsultationType?: MemberProductPaymentRatesChargeCode;
  serviceOfferingUsageItems: MemberServiceOfferingUsage[];
}

export default function AvailablePromoCodesModal({
  isModalOpen,
  onModalClose,
  onContinueButtonClick,
  onSkipButtonClick,
  selectedConsultationType,
  serviceOfferingUsageItems,
}: AvailablePromoCodesModalProps) {
  const isVoucherEnabled = isFeatureEnabled(
    FeatureToggleIdentifier.ENABLE_VOUCHER_REDEMPTION
  );

  function filterServiceOfferingUsageItems(
    serviceOfferingUsageItems: MemberServiceOfferingUsage[]
  ) {
    if (selectedConsultationType) {
      return serviceOfferingUsageItems.filter(
        (usage) => usage.chargeCode === selectedConsultationType
      );
    } else {
      return serviceOfferingUsageItems;
    }
  }

  return (
    <>
      {isVoucherEnabled ? (
        <AvailablePromoCodesModalV2
          isModalOpen={isModalOpen}
          onModalClose={onModalClose}
          onContinueButtonClick={onContinueButtonClick}
          serviceOfferingUsageItems={filterServiceOfferingUsageItems(
            serviceOfferingUsageItems
          )}
        />
      ) : (
        <AvailablePromoCodesModalV1
          isModalOpen={isModalOpen}
          onModalClose={onModalClose}
          onContinueButtonClick={onContinueButtonClick}
          onSkipButtonClick={onSkipButtonClick}
          serviceOfferingUsageItems={serviceOfferingUsageItems}
        />
      )}
    </>
  );
}
